var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarred2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4816 2.72668L12.8748 5.53607C13.0648 5.92715 13.5714 6.30226 13.9989 6.37409L16.524 6.7971C18.1388 7.06846 18.5188 8.24968 17.3552 9.41493L15.392 11.3943C15.0596 11.7295 14.8775 12.376 14.9804 12.8389L15.5424 15.2891C15.9857 17.2285 14.9646 17.9788 13.2627 16.9652L10.8959 15.5525C10.4684 15.2971 9.76392 15.2971 9.32855 15.5525L6.96173 16.9652C5.26775 17.9788 4.2387 17.2206 4.68198 15.2891L5.244 12.8389C5.34691 12.376 5.16484 11.7295 4.83238 11.3943L2.86926 9.41493C1.71356 8.24968 2.0856 7.06846 3.70042 6.7971L6.22556 6.37409C6.6451 6.30226 7.15171 5.92715 7.34169 5.53607L8.73487 2.72668C9.49478 1.20227 10.7296 1.20227 11.4816 2.72668Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarred2);
export default __webpack_public_path__ + "static/media/starred (2).02414d2a642261bdb99980182f6bf20d.svg";
export { ForwardRef as ReactComponent };